import { ChatCircleDots } from '@phosphor-icons/react';

import { useOpenSupportChat } from '@/shared/support/supportChat';
import { InvoiceButton } from './InvoiceButton';

/**
 * Salida a soporte para lo que el usuario no puede resolver solo con sus
 * sellos (vencidos, de otro RFC, un trámite a medias). Abre el chat de soporte
 * de la app; el mensaje llega como borrador con el contexto para que no
 * tengan que preguntarlo.
 */
export const SealSupportButton = ({
  context,
  variant = 'primary',
}: {
  /** Qué pasó, en una frase: va al final del mensaje prellenado. */
  context: string;
  variant?: 'primary' | 'secondary';
}) => {
  const openSupportChat = useOpenSupportChat();
  return (
  <InvoiceButton
    variant={variant}
    className='flex-none whitespace-nowrap'
    iconLeft={<ChatCircleDots size={16} weight='fill' />}
    onClick={() =>
      openSupportChat(
        'sellos_ayuda',
        `Hola, necesito ayuda con mis sellos digitales (CSD) para facturar en heru. ${context}`,
      )
    }>
    Escríbenos por chat
  </InvoiceButton>
  );
};
